<router-outlet></router-outlet>
@if (envLabel) {
  <div class="env-ribbon" aria-hidden="true">{{ envLabel }}</div>
}
